import modules from './modules';

export default {
    namespaced: true,
    modules,
};
